import React from "react";
import { CollapsibleItem } from "react-materialize";
import { useInfo } from "context/InfoContext";
import ReportItems from "./ReportItems";

export default function DashboardReportContent({
  boxName,
  userData,
  handleEvents,
}) {
  const { filters, filterData } = useInfo();
  return (
    <>
      {Object.keys(filterData.data.rep_group_data)?.map((rep_group_id, i) => {
        if (filterData?.data?.rep_data_by_group?.[rep_group_id]) {
          const item = filterData.data.rep_group_data[rep_group_id];
          if (item.status === 0) return "";
          const header = <h6>{item.name}</h6>;
          const keyId =
            "dashboard-report-content-" +
            rep_group_id +
            "-" +
            boxName +
            "-" +
            filters.key_form;
          return (
            <CollapsibleItem
              key={keyId}
              className="collap-item collap-rep-group-item"
              expanded={true}
              header={header}
              //icon={<Icon>filter_drama</Icon>}
              node="div"
            >
              <ReportItems
                data={{
                  inx: i,
                  rep_group_name: item.name,
                  rep_group_id: rep_group_id,
                  rep_data: filterData.data.rep_data_by_group[rep_group_id],
                  rep_group_all_countries:
                    filterData.data.rep_group_all_countries ?? [],
                  countries: filterData.data.countries,
                  user_countries_access: filters?.user_countries_access ?? [],
                  user_relate_report: filters.user_relate_report ?? [],
                  user_reports_access: filters?.user_reports_access ?? [],
                  report_countries: filters?.report_countries ?? {},
                  user_group_relate_report:
                    filters?.user_group_relate_report ?? [],
                }}
                handleEvents={handleEvents}
              />
            </CollapsibleItem>
          );
        } else {
          return "";
        }
      })}
    </>
  );
}
